import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  AdminNotificationType,
  GetAdminNotificationFeedOutputDto,
} from '../../../models/admin-notification/dto/admin-notification-feed.dto';

export const ADMIN_NOTIFICATION_FEED_QUERY_KEY = 'admin-notification-feed';

export const useGetAdminNotifications = (params: {
  organizationId?: string;
  page?: number;
  limit?: number;
  type?: AdminNotificationType;
  isRead?: string;
}) => {
  const client = useApiClient();
  const page = params.page ?? 0;
  const limit = params.limit ?? 20;

  return useQuery({
    queryKey: [ADMIN_NOTIFICATION_FEED_QUERY_KEY, page, limit, params.organizationId, params.type, params.isRead],
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page.toString());
      queryParams.append('limit', limit.toString());
      if (params.organizationId) queryParams.append('organizationId', params.organizationId);
      if (params.type) queryParams.append('type', params.type);
      if (params.isRead) queryParams.append('isRead', params.isRead);

      return client.fetchApi<GetAdminNotificationFeedOutputDto, {}>({
        endpoint: `notifications/admin/feed?${queryParams.toString()}`,
        method: 'GET',
      });
    },
    enabled: !!params.organizationId,
    staleTime: 30_000,
    cacheTime: 5 * 60_000,
    keepPreviousData: true,
  });
};
